import React, { HTMLAttributes } from 'react';
import { classNames } from '../../utilities';
import './SuccessCheckmark.scss';

export interface SuccessCheckmarkProps extends HTMLAttributes<HTMLElement> {
  className?: string;
}

const SuccessCheckmark = (props: SuccessCheckmarkProps) => {
  const { className } = props;
  const rootClassNames = classNames('ps-success-checkmark', className);

  return (
    <svg className={rootClassNames} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
      <circle className="line circle" strokeWidth="6" strokeMiterlimit="10" cx="75" cy="75" r="70" />
      <polyline
        className="line check"
        strokeWidth="13"
        strokeLinecap="round"
        strokeMiterlimit="10"
        points="110,51 65,100 38,75"
      />
    </svg>
  );
};

export { SuccessCheckmark };
